import { Col, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import FormWithProvider from '../../../../forms/form/Form';
import TextField from '../../../../forms/textField/TextField';
import SelectField from '../../../../forms/selectField/SelectField';
import { BookingDotComDeclineReason } from '../LeadActions.types';
import Button from '../../../../button/Button';

const declineFormSchema = () => ({
  bookingDotComDeclineReason: Yup.mixed<BookingDotComDeclineReason>()
    .oneOf(Object.values(BookingDotComDeclineReason))
    .required(),
  bookingDotComDeclineReasonText: Yup.string().when(
    'bookingDotComDeclineReason',
    {
      is: BookingDotComDeclineReason.NOT_COMFORTABLE,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired().nullable(),
    },
  ),
});

const declineFormDefaultValues = {
  bookingDotComDeclineReason: BookingDotComDeclineReason.DATES_NOT_AVAILABLE,
};

const DeclineBCLeadModalContent = ({
  onCancel,
  onSubmit,
}: {
  onCancel: () => void;
  onSubmit: (data: any) => void;
}) => {
  const { t } = useTranslation();

  const declineReasonOptions = Object.values(BookingDotComDeclineReason).map(
    (reason: BookingDotComDeclineReason) => ({
      label: t(
        `componentLead.actionsInfo.bookingdotcom.declineReason.${reason}`,
      ),
      value: reason,
    }),
  );

  return (
    <FormWithProvider
      defaultValues={declineFormDefaultValues}
      onSubmit={onSubmit}
      schema={declineFormSchema()}
    >
      <ModalBody>
        <Row>
          <Col>
            <SelectField
              label={t(
                'componentLead.actionsInfo.bookingdotcom.declineReasonSelect',
              )}
              name="bookingDotComDeclineReason"
              options={declineReasonOptions}
              colSmInput={8}
              colSmLabel={4}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField
              label={t(
                'componentLead.actionsInfo.bookingdotcom.bookingDotComDeclineReasonText',
              )}
              name="bookingDotComDeclineReasonText"
              colSmInput={8}
              colSmLabel={4}
              componentClass="textarea"
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button bsStyle="danger" type="submit">
          {t('componentLead.actionsInfo.bookingdotcom.declineConfirm')}
        </Button>
      </ModalFooter>
    </FormWithProvider>
  );
};

export default DeclineBCLeadModalContent;
